<template>
  <div class="group-management">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.manageMyGroups')">
    </NavHeaderBar>
    <!-- + 添加新分组 -->
    <div class="add-new" @click="handleOper('add')">+ {{ $t('button.addNewGroup') }}</div>
    <div class="management-section">
      <div class="management-item" v-for="subItem in groupList" :key="subItem.id">
        <div class="item-left van-ellipsis">{{ subItem.labelName }}</div>
        <div class="item-right">
          <img class="edit-img" src="@/assets/images/incentive_edit.png" alt="" @click="handleOper('edit', subItem)">
          <img class="del-img" src="@/assets/images/event_del.png" alt="" @click="handleOper('del', subItem)">
        </div>
      </div>
    </div>
    <van-dialog v-model="editShow" :title="dialogTitle" show-cancel-button :confirm-button-text="$t('button.confirm')" confirmButtonColor="#307bff" :cancel-button-text="$t('button.cancel')" @confirm="handleConfirm">
      <div class="dialog-content">
        <van-field v-model="labelName" placeholder="" class="group-input" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { arsLabelListApi, arsLabelDeleteByIdApi, arsLabelAddOrUpdateApi } from '@/api/storePage'
import { Toast, Dialog } from 'vant'
export default {
  data () {
    return {
      groupList: [],
      editShow: false,
      dialogTitle: '',
      currentId: '',
      currentData: {},
      labelName: ''
    }
  },
  activated () {
    this.getLabelData()
  },
  methods: {
    handleConfirm () {
      if (!this.labelName) {
        Toast(this.$t('tips.pleaseEnterGroupName'))
        return
      }
      const data = {
        id: this.currentData.id || '',
        type: 0,
        labelName: this.labelName
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsLabelAddOrUpdateApi(data).then(res => {
        Toast.clear()
        this.getLabelData()
        this.editShow = false
      })
    },
    getLabelData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsLabelListApi('').then(res => {
        Toast.clear()
        this.groupList = res.data
      })
    },
    handleOper (type, params = {}) {
      if (['add', 'edit'].includes(type)) {
        this.currentData = params
        this.labelName = params.labelName || ''
        this.dialogTitle = type === 'add' ? this.$t('shared.title.createANewGroup') : this.$t('shared.title.editGroupName')
        this.editShow = true
      } else if (type === 'del') {
        Dialog.confirm({
          message: this.$t('tips.messageFortyEight'), // 删除该分组（该操作仅删除分组不会删除分组下的门店）
          confirmButtonText: this.$t('button.delete'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#d9001b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            arsLabelDeleteByIdApi(params.id).then(res => {
              Toast.clear()
              this.getLabelData()
            })
          })
          .catch(() => {
            // on cancel
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.group-management {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 10px;
  .add-new {
    padding: 10px 0;
    color: #307bff;
    font-size: 14px;
    border-bottom: 1px solid #f2f2f2;
  }
  .management-section {
    flex: 1;
    .management-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 8px;
      border-bottom: 1px solid #f2f2f2;
      font-size: 13px;
      .item-left {
        flex: 1;
      }
    }
    .edit-img,
    .del-img {
      width: 17px;
      height: 17px;
    }
    .edit-img {
      margin-right: 10px;
    }
  }
}
.dialog-content {
  padding: 20px 16px;
  .group-input {
    border: 1px solid #ebedf0;
    border-radius: 4px;
    padding: 5px 10px;
  }
}
</style>
